const danger40 = "#DC3838";
const warning60 = "#8f4200";
const highlightAmber = "#ffefde"

export {danger40, warning60, highlightAmber};